import {BrickContext, Brick, registerBrick, QueryResult} from 'olympe';
import {format} from "date-fns";

export default class TransformOrdersToBalanceLines extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Array} orders
     * @param {Array} candles
     * @param {function()} forwardEvent
     * @param {function(Array)} setMarkLines
     */
    update($, [orders, candles], [forwardEvent, setMarkLines]) {

        if (orders instanceof QueryResult) {
            orders = orders.map(o => o.toJSON()).filter(o => o.close !== undefined);
        }
        if (candles instanceof QueryResult) {
            candles = candles.map(c => c.toJSON());
        }

        let currentBalance = orders[0]?.amountOpen ?? 0; // Ensure there's an initial balance
        let orderIndex = 0; // Pointer for orders list
        orders.forEach(o => {
            o.close = new Date(o.close);
        });

        setMarkLines(
            candles.map(candle => {
                const candleTime = new Date(candle.openTime ?? candle.timeFrom).getTime();
                const candleTimeStr = format(new Date(candleTime), 'dd.MM.yyyy HH:mm');

                // Move orderIndex forward while it's still behind candleTime
                while (orderIndex < orders.length) {
                    const orderCloseTime = new Date(orders[orderIndex].close + (typeof orders[orderIndex].close === 'number' ? 1000 : '')).getTime();
                    const orderCloseTimeStr = format(new Date(orderCloseTime), 'dd.MM.yyyy HH:mm');

                    if (orderCloseTime > candleTime) break; // Stop when orderCloseTime surpasses candleTime

                    // If orderCloseTime matches candleTime, update balance
                    // if (orderCloseTimeStr === candleTimeStr) {
                    currentBalance = orders[orderIndex].balance;
                    if (orders[orderIndex].openLoss) {
                        currentBalance += orders[orderIndex].openLoss;
                    }
                    // }

                    orderIndex++; // Move to the next order
                }

                return [format(candleTime, 'dd.MM.yyyy HH:mm'), currentBalance];
            })
        );
        forwardEvent();
    }
}

registerBrick('0194f3e3fd4ea4b4795a', TransformOrdersToBalanceLines);
